export default [
  {
    name: 'monitored-event-profile-create',
    path: '/events/profile/monitored/create',
    component: () => import('@/views/events/profiles/EventProfileManage')
  },
  {
    name: 'monitored-event-profile-edit',
    path: '/events/profile/:id/monitored/edit',
    component: () => import('@/views/events/profiles/EventProfileManage')
  },
  {
    name: 'monitored-event-profile-view',
    path: '/events/profile/:id/monitored/view',
    component: () => import('@/views/events/profiles/EventProfileManage')
  },
  {
    name: 'monitored-event-profile-find',
    path: '/events/profile/monitored/find',
    component: () => import('@/views/events/profiles/EventProfileFind')
  },
  {
    name: 'client-event-profile-create',
    path: '/events/profile/client/create',
    component: () => import('@/views/events/profiles/EventProfileManage')
  },
  {
    name: 'client-event-profile-edit',
    path: '/events/profile/:id/client/edit',
    component: () => import('@/views/events/profiles/EventProfileManage')
  },
  {
    name: 'client-event-profile-view',
    path: '/events/profile/:id/client/view',
    component: () => import('@/views/events/profiles/EventProfileManage')
  },
  {
    name: 'client-event-profile-find',
    path: '/events/profile/client/find',
    component: () => import('@/views/events/profiles/EventProfileFind')
  },
  {
    name: 'client-event-profile-clone',
    path: '/events/profile/client/clone',
    component: () => import('@/views/events/profiles/CloneClientEventProfileWizard')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeEventProfiles.js